import { render, staticRenderFns } from "./AdminFormsData.vue?vue&type=template&id=53ac9ee4&scoped=true&"
import script from "./AdminFormsData.vue?vue&type=script&lang=js&"
export * from "./AdminFormsData.vue?vue&type=script&lang=js&"
import style0 from "./AdminFormsData.vue?vue&type=style&index=0&id=53ac9ee4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ac9ee4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53ac9ee4')) {
      api.createRecord('53ac9ee4', component.options)
    } else {
      api.reload('53ac9ee4', component.options)
    }
    module.hot.accept("./AdminFormsData.vue?vue&type=template&id=53ac9ee4&scoped=true&", function () {
      api.rerender('53ac9ee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminFormsData.vue"
export default component.exports